<template>
    <div
            class="modal fade"
            id="deal-select-box"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deals-widget-twitter"
            aria-hidden="true"
    >
        <div class="modal-dialog window-popup edit-widget edit-widget-twitter" role="document">
            <div class="modal-content" ref="searchContent">
                <a href="#" class="close icon-close" data-dismiss="modal" aria-label="Close">
                    <svg class="olymp-close-icon">
                        <use xlink:href="/svg-icons/sprites/icons.svg#olymp-close-icon" />
                    </svg>
                </a>

                <div class="modal-header">
                    <h6 class="title">Choose how you want to place your deal</h6>
                </div>

                <div class="modal-body">
                    <button @click="emitDealsBox" class="btn bg-breez mr-3 btn-lg btn-icon-left">Place by match</button>
                    <button @click="setMatch" class="btn bg-mdd btn-lg btn-icon-left">Place deal</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "dealOption",
        data() {
            return {

            }
        },
        methods: {
            emitDealsBox() {
                window.eventBus.$emit("dealsBox", true);
                $("#deal-select-box").modal("hide");
                // console.log('Clicked for deals');
            },
            setMatch() {
                $('#deals-my-poll-popup').modal('show');
                var matchId = 0;
                window.eventBus.$emit("dealsMatchID", matchId);
            },
        },
    }
</script>

<style scoped>

</style>
